import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { EventProductMainReport } from '@/model/EventProductMainReport';
import { SaleProductProductsContent } from './ui';
import { ReportControllerProps } from '../../types';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductProducts: React.FC<StateProps> = ({ reportController, setState }) => {
  const { eventId, singleEvent } = reportController;
  const [main, setMain] = useState<EventProductMainReport>({
    products: [],
    courtesies: [],
  });

  const handleGetSaleProducts = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventProductMainReport>(
        `event/report/${eventId}/sale-product/product?singleEvent=${singleEvent}`,
      );
      if (data) {
        setMain(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, []);
  return <SaleProductProductsContent main={main} />;
};
